module.exports = __webpack_public_path__ + "static/img/xiaozu.397b527.png";


//////////////////
// WEBPACK FOOTER
// ./static/xiaozu.png
// module id = XKAp
// module chunks = 1